// Import plugin.
import React from 'react';
import ReactDOM from 'react-dom';
require('es6-promise').polyfill();
const _ = require("underscore");

class Cards extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      cardAmount: 16,
      jsonAmount: 0,
      fetch: false,
      cardList: {},
      cashList: {},
      filtering: false,
      cardAlignmentAnimation: true
    };
  }
  
  componentDidMount(props){
    // tranc polyfill for ie11
    Math.trunc = Math.trunc || function(x) {
      return x < 0 ? Math.ceil(x) : Math.floor(x);
    }
    // カード遅延読み込み
    const lazyLoad = () => {
      if(this.state.cardList.length !== 0){
        const windowStatus = {
          "documentHeight": document.body.clientHeight,
          "documentWidth": window.innerWidth,
          "scrollPos": ( window.scrollY || window.pageYOffset ) + window.innerHeight
        }
        
        const cardColumnRatio = {
          "containerWidth": document.getElementById("cards").getBoundingClientRect().width - Number(getComputedStyle(document.querySelector("#cards")).paddingTop.replace(/px/g, "")),
          "cardWidth": document.getElementsByClassName("cards__card")[0].getBoundingClientRect().width
        }
        
        const RATIO = 50;
        if(windowStatus.documentHeight - RATIO <= windowStatus.scrollPos){
          this.setState({ cardAmount: this.state.cardAmount + Math.trunc(cardColumnRatio.containerWidth / cardColumnRatio.cardWidth) });
          const FIL_ITEM = _.filter(this.state.cashList, (e, num) => {
            return num < this.state.cardAmount;
          });
          this.setState({ cardList: FIL_ITEM });
        }
      }
    }
    window.addEventListener("scroll", (e) => { lazyLoad(); }, true);
  }
  
  UNSAFE_componentWillReceiveProps(nextProps){
    this.setState({
      jsonAmount: Object.keys(nextProps["jsonData"]).length
    });
    if(nextProps.panelHandle){
      Promise.resolve()
        .then(() => {
          this.setState({
            cardAmount: 12,
            cardAlignmentAnimation: false
          });
        }).then(() => {
          const SEARCHER = Object.assign({}, this.props.panelHandle);
          const searchWhen = _.where(nextProps["jsonData"], _.omit(SEARCHER, "order", "filter"));
          const searchFilter = (value, panel) => {
            let tmpArray = [];
            if(panel){
              value.forEach((e) => {
                const FILL_ARRAY = _.find(e.filter, (string) => {
                  return string === panel;
                });
                if(FILL_ARRAY){
                  tmpArray.push(e);
                }
              });
              return tmpArray;
            }
            return value;
          }
          const sortCard = (array) => {
            if(SEARCHER["order"]){
              if(SEARCHER["order"] === "新しい順"){
                array = this.sortByTimeEarlier(array);
              }else if(SEARCHER["order"] === "古い順"){
                array = this.sortByTimeOlder(array);
              }
              return array;
            }else{
              array = this.sortByTimeEarlier(array);
              return array;
            }
          }
          let fullArray = sortCard(searchFilter(searchWhen, this.props.panelHandle["filter"]));
          this.setState({
            cashList: fullArray
          });
          fullArray = _.filter(fullArray, (e, num) => {
            return num < this.state.cardAmount;
          });
          
          this.setState({
            cardList: fullArray
          });
          setTimeout(() => {
            this.setState({
              cardAlignmentAnimation: true
            });
          }, 50);
        });
    }else{
      const SORT_BY_EARLIER = this.sortByTimeEarlier(nextProps["jsonData"]);
      // Init load.
      this.setState({
        cashList: SORT_BY_EARLIER
      });
      if(!this.state.fetch){
        let initList = SORT_BY_EARLIER;
        initList = _.filter(initList, (e, num) => {
          return num < this.state.cardAmount;
        });
        this.setState({
          fetch: true,
          cardList: initList
        });
      }
    }
  }
  
  sortByTimeEarlier(value){
    value = _.sortBy(value, (o) => { return -Number(o.date) });
    value = _.sortBy(value, (o) => { return -Number(o.month) });
    value = _.sortBy(value, (o) => { return -Number(o.year) });
    return value;
  }
  
  sortByTimeOlder(value){
    value = _.sortBy(value, (o) => { return Number(o.date) });
    value = _.sortBy(value, (o) => { return Number(o.month) });
    value = _.sortBy(value, (o) => { return Number(o.year) });
    return value;
  }
  
  render(){
    return(
      <div id="cards" className={ this.state.cardAlignmentAnimation ? "alignmentAnimation" : null }>
        {
          (() => {
            if(!this.state.cashList.length){
              return <a className="cards__card cards__card--noData">
                <span></span>
              </a>
            }
          })()
        }
        {
          Object.keys(this.state.cardList).map((e) => {
            const LIST = this.state.cardList[e];
            return <a key={ e } data-holding={ LIST.hold } style={{ backgroundImage: "url(" + LIST.img + ")" }} href={ LIST.link }
            className="cards__card" target="_blank" data-date={ LIST.year + " / " + LIST.month }>
              <span></span>
            </a>
          })
        }
        <Loading cardAmount = { this.state.cardAmount } cashList = { this.state.cashList } />
      </div>
    );
  }
}

const Loading = (props) => {
  return(
    <div id="loading" style={ props.cardAmount > props.cashList.length 
    ? { display: "none" } : { display: "block" } }></div>
  );
}

export default Cards;